// --- Shared Camera / Canvas Constants ---
export const CANVAS_WIDTH = 640;
export const CANVAS_HEIGHT = 480;
export const CANVAS_FPS = 5;
export const CAMERA_FPS = 15;
export const JPEG_QUALITY = 0.8;

// --- Animation ---
export const IOS_SPRING = { type: 'spring', stiffness: 340, damping: 32 };

// --- PiP (Picture-in-Picture) ---
export const PIP_SIZE = { width: 120, height: 160 };
export const PIP_EXPANDED_SIZE = { width: 240, height: 320 };
export const PIP_MARGIN = 16;
export const PIP_SPRING = { type: 'spring', stiffness: 300, damping: 30 };
